import React from 'react'
import AuthCodeModal from '../components/Activate/AuthCodeModal'

// can add more app common comp here
const AppCommonAddons = () => <>
  <AuthCodeModal />
</>

export default AppCommonAddons
